import { Component, OnInit, Renderer2 } from '@angular/core';
import { Spinkit } from 'ng-http-loader';
import { AppInsightsService } from './framework/service/app-insights.service';
import { BaseUrl } from './framework/constants/url-constants';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { RoutePartsService } from './framework/service/route-parts.service';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { SessionsService } from './sessions/sessions.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {

  appTitle = BaseUrl.APPTITLE;
  public spinkit = Spinkit;
  pageTitle = '';
  clientDetails;
  logo: string;

  constructor(
    public title: Title,
    private readonly appInsightsService: AppInsightsService,
    private readonly router: Router,
    private readonly routePartsService: RoutePartsService,
    private readonly activeRoute: ActivatedRoute,
    private readonly sessionsService: SessionsService,
    private readonly renderer: Renderer2
  ){
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateBodyClass(event.urlAfterRedirects);
      }
    });
  }


  private updateBodyClass(navigatedUrl: string): void {
    const body = document.body;

    body.classList.remove('uw-class');

    if (navigatedUrl.includes('myunity')) {
      body.classList.add('uw-class1');
    } else if (navigatedUrl.includes('mnprt')) {
      body.classList.add('aladdin-app');
    }
  }
  ngOnInit() {
    this.setInitialData();
    this.changePageTitle();
    this.onload();
      this.sessionsService.currentLogo.subscribe(logo => {    
        this.logo = logo +  localStorage.getItem('logoPath');
    });
    this.applyUserway();
    this.aladdinLogo();
  }

  ngAfterViewInit(): void {
    
    var msClarityCode = null;
    msClarityCode = environment.microsoftClarityProjectId;
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }; // NOSONAR
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i + "?cross_domain=true";
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", msClarityCode);
  }
  
  changePageTitle() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((routeChange) => {
      const routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
      this.appInsightsService.logPageView(window.location.hash.split('/')[1]);
      if (!routeParts.length) {
        return this.title.setTitle(this.appTitle);
      }

      routeParts.reverse();
      this.pageTitle = routeParts
        .map((part) => part.title)
        .reduce((partA, partI) => `${partI}`);
      this.pageTitle += ` | ${this.appTitle}`;
      this.title.setTitle(this.pageTitle);
    });
  }

  darkmode() {
    const element = document.body;
    element.classList.toggle('dark-mode');
    if( localStorage.getItem('darkmode') === 'true' ){
      localStorage.setItem('darkmode', 'false');
    }else{
      localStorage.setItem('darkmode', 'true');
    }
  }

  onload() {
    document.body.classList.toggle('dark-mode', localStorage.getItem('darkmode') === 'true');
  }
  
  
  async setInitialData() {
      await this.sessionsService.getClientDetails().toPromise().then(data => {
        if(data.id) {
        localStorage.setItem('clientId', data.id);
        localStorage.setItem('logoPath', data.logoPath);
        localStorage.setItem('ApplicationID',data.appId);
        localStorage.setItem('suAppId',data.serviceUserAppId);
        if (localStorage.getItem('landingPage') === null) {
          localStorage.setItem('landingPage', data.landingPageUrl);
        }
        localStorage.setItem('primaryAppColour',data.primaryAppColour);
        localStorage.setItem('secondaryAppColour',data.secondaryAppColour);
        localStorage.setItem('moodleUrl',data.moodleUrl);
        localStorage.setItem('isExternalMoodle',data.isExternalMoodle);
        localStorage.setItem('identifier', data.identifier);
        document.documentElement.style.setProperty('--primary-color', data.primaryAppColour);
        document.documentElement.style.setProperty('--secondary-color', data.secondaryAppColour);
        
        if(data.identifier =='RWH') {
          document.documentElement.style.setProperty('--loaderUrl', 'url(../assets/new_RW_Loading_Icon.gif)');
          document.documentElement.style.setProperty('--loaderFilter','none')
        }
        
      }
      });
  }

  applyUserway() {
    let currentUrl  = window.location.href;
    if(currentUrl .includes('test-staff') || currentUrl .includes('test-myunitypathwaystaff')){
      this.renderer.addClass(document.body, 'userway');
    }
  }

  aladdinLogo() {
    let currentUrl  = window.location.href;
    if(currentUrl .includes('mnprt')){
      this.renderer.addClass(document.body, 'aladdin-app');
    }
  }
}
